const translations = {
    title: {
        homePage: 'Plantilla de complementos',
        exemples: 'Ejemplos',
        systemInfo: 'Información del sistema',
        userInfo: 'Información del usuario'
    },
    paragraph: {
        homeDescription: {
            part1: 'Esta es una plantilla de complemento básica',
            part2: 'Edite <1>src/pages/Home.js</1> y guarde para recargar.'
        }
    },
    link: {
        blipDataExample: 'Obtener datos de blip',
        swrExemple: 'Obtener datos con SWR'
    },
    button: {
        repository: 'Visite el Repositorio'
    },
    menu: {
        goBack: 'Volver'
    },
    name: 'Nombre',
    shortName: 'Nombre corto',
    email: 'E-mail',
    phone: 'Teléfono',
    identity: 'Identificador',
    identifier: 'Identificador',
    language: 'Idioma',
    accessKey: 'Llave de acceso',
    template: 'Plantilla',
    creationDate: 'Fecha de creación'
};

export default translations;
